var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "flex-end",
            width: "100%"
          }
        },
        [
          _c("div", { staticClass: "ui compact menu" }, [
            _c(
              "div",
              {
                staticClass: "link item",
                class: { active: _vm.currentView === "overview" },
                on: {
                  click: function($event) {
                    _vm.currentView = "overview"
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("pages.bookings.reserved_bookings.labels.overview")
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "link item",
                class: { active: _vm.currentView === "calendar" },
                on: {
                  click: function($event) {
                    _vm.currentView = "calendar"
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("pages.bookings.reserved_bookings.labels.calendar")
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.currentView === "overview"
        ? [
            _c(
              "table",
              { staticClass: "ui celled table reserved-booking-table" },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.headers, function(header, key) {
                        return _c(
                          "th",
                          {
                            key: key,
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.applySort(header)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "pages.bookings.reserved_bookings.table." +
                                      key
                                  )
                                ) +
                                "\n            "
                            ),
                            _vm.currentSortField === header
                              ? _c("i", {
                                  staticClass: "angle icon",
                                  class: {
                                    down: _vm.currentSortType === "ASC",
                                    up: _vm.currentSortType === "DESC"
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pages.bookings.reserved_bookings.table.actions"
                            )
                          )
                        )
                      ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.sortedBookings, function(booking) {
                    return _c("tr", { key: booking.id }, [
                      _c("td", [
                        _c("div", { staticClass: "booking-col" }, [
                          _c("span", { staticClass: "booking-col-name" }, [
                            _vm._v("Product:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "booking-col-value" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(booking.booking.product.name) +
                                "\n                "
                            ),
                            booking.has_guest
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "guest-booking-indicator",
                                    attrs: {
                                      title: _vm.$t(
                                        "modals.newbookingmodal.guest.included"
                                      )
                                    }
                                  },
                                  [_c("i", { staticClass: "users icon" })]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "booking-col" }, [
                          _c("span", { staticClass: "booking-col-name" }, [
                            _vm._v("Start time:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "booking-col-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("date")(
                                  booking.start_time,
                                  "Do MMM, YYYY HH:mm:ss"
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "booking-col" }, [
                          _c("span", { staticClass: "booking-col-name" }, [
                            _vm._v("End time:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "booking-col-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("date")(
                                  booking.end_time,
                                  "Do MMM, YYYY HH:mm:ss"
                                )
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "booking-col" }, [
                          _c("span", { staticClass: "booking-col-name" }, [
                            _vm._v("Status:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "booking-col-value" }, [
                            _c(
                              "div",
                              {
                                staticClass: "ui label",
                                class: [
                                  { green: booking.status == "active" },
                                  { red: booking.status == "deleted" }
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t("globals.status." + booking.status)
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "booking-col" }, [
                          _c("span", { staticClass: "booking-col-name" }, [
                            _vm._v("Price:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "booking-col-value" },
                            [
                              _vm.totalPrice(booking) > 0
                                ? [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("money")(
                                            _vm.safeObjectGet(booking, "price")
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "pages.bookings.reserved_bookings.labels.free"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ],
                              _vm._v(" "),
                              (_vm.safeObjectGet(booking, "startup_fee") ===
                                "requested" ||
                                _vm.safeObjectGet(booking, "startup_fee") ===
                                  "completed") &&
                              _vm.safeObjectGet(booking, "status") !== "active"
                                ? [
                                    _c("br"),
                                    _vm._v(
                                      "+ " +
                                        _vm._s(
                                          _vm._f("money")(
                                            _vm.safeObjectGet(
                                              booking,
                                              "booking.product.fee_amount"
                                            )
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("div", { staticClass: "booking-col" }, [
                          _c("span", { staticClass: "booking-col-name" }, [
                            _vm._v("Actions:")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "booking-col-value" }, [
                            (_vm.safeObjectGet(booking, "status") === "unset" ||
                              _vm.safeObjectGet(booking, "status") ===
                                "activating") &&
                            _vm.currentTime <
                              _vm.safeObjectGet(booking, "start_time")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ui blue mini button",
                                    on: {
                                      click: function($event) {
                                        return _vm.payForBooking(booking)
                                      }
                                    }
                                  },
                                  [
                                    booking.is_free && !booking.has_guest
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pages.bookings.reserved_bookings.labels.activate"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pages.bookings.reserved_bookings.labels.pay"
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.safeObjectGet(booking, "status") === "active" &&
                            _vm.safeObjectGet(booking, "payment_method") !==
                              "mobile_pay" &&
                            _vm.safeObjectGet(booking, "payment_method") !==
                              "vipps" &&
                            _vm.currentTime <
                              _vm.safeObjectGet(booking, "start_time") &&
                            _vm.totalPrice(booking) > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ui blue mini button",
                                    on: {
                                      click: function($event) {
                                        return _vm.payForBooking(booking, true)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("globals.buttons.edit")) +
                                        "\n                "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showCancelButton(booking)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "ui grey mini button",
                                    on: {
                                      click: function($event) {
                                        return _vm.confirmDeletion(booking.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "globals.buttons.cancel_booking"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c("tfoot", { staticClass: "full-width" })
              ]
            ),
            _vm._v(" "),
            _vm.booked.last_page > 1
              ? _c(
                  "div",
                  { staticClass: "ui pagination menu" },
                  _vm._l(_vm.booked.last_page, function(amount) {
                    return _c(
                      "a",
                      {
                        key: amount,
                        staticClass: "item",
                        class: { active: amount === _vm.currentPage },
                        on: {
                          click: function($event) {
                            _vm.currentPage = amount
                          }
                        }
                      },
                      [_vm._v("\n          " + _vm._s(amount) + "\n        ")]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.currentView === "calendar"
        ? _c(
            "div",
            { staticClass: "ui segment" },
            [
              _c("FullCalendar", {
                attrs: {
                  locale: _vm.calendarConfig.locale,
                  defaultView: "dayGridMonth",
                  events: _vm.bookingEvents,
                  plugins: _vm.calendarPlugins,
                  "event-render": _vm.customCalendarRender
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: {
            active: _vm.deleteBookingModal,
            icons: "big calendar alternate outline",
            title: _vm.$t("pages.bookings.validation.delete_booking.title"),
            popout: true
          },
          on: {
            acceptmodal: function($event) {
              return _vm.deleteBooking(_vm.deleteBookingId)
            },
            denymodal: function($event) {
              return _vm.cancelDeletion()
            }
          }
        },
        [
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("pages.bookings.validation.delete_booking.header"))
            )
          ]),
          _vm._v(" "),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("pages.bookings.validation.delete_booking.text")
              )
            }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "box-actions" }, slot: "box-actions" }, [
            _c(
              "div",
              {
                staticClass: "ui red basic circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.modal.denyModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("globals.buttons.no")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui blue circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.modal.acceptModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("globals.buttons.yes")) +
                    "\n        "
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: {
            active: _vm.showUpdateBookingNotice,
            title: _vm.$t("modals.payment_system_update.title"),
            icons: "big alarm"
          },
          on: {
            acceptmodal: _vm.openCheckoutPage,
            denymodal: _vm.closeUpdateModal
          }
        },
        [
          _c("h4", [
            _vm._v(
              _vm._s(
                _vm.$t("modals.payment_system_update.header", {
                  firstname: this.$auth.user().firstname,
                  surname: this.$auth.user().surname
                })
              )
            )
          ]),
          _vm._v(" "),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("modals.payment_system_update.body", {
                  container: _vm.$t("globals.container.booked"),
                  product_name: this.bookedActiveProductName
                })
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ui" },
        [
          _vm.selectedBooking !== null
            ? _c("new-booking-modal", {
                attrs: {
                  active: _vm.showPaymentModal,
                  bookingid: _vm.selectedBooking.booking.id,
                  selectedPlace: _vm.selectedPlace,
                  "update-booking": _vm.selectedBooking,
                  update: true
                },
                on: {
                  onClose: function($event) {
                    _vm.selectedBooking = null
                  },
                  "open-image": _vm.handleOpenImage
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showWinterPlaceModal
            ? _c("winter-place-modal", {
                attrs: { "selected-map-element": _vm.selectedSpot },
                on: {
                  close: function($event) {
                    _vm.showWinterPlaceModal = false
                  },
                  "polygon-selected": _vm.handlePolygonSelected
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcc3f3da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcc3f3da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/booking/ReservedBookings.vue
// module id = Z+93
// module chunks = 1